<template>
  <div class="home">
    <header-bar></header-bar>
    <user-head></user-head>
    <section class="main">
      <user-nav></user-nav>
      <div class="mainconten-right">
        <ul class="tab-bar cl">
          <li @click="tabClick(1)" :class="{ active: type == 1 }">评论</li>
          <li @click="tabClick(2)" :class="{ active: type == 2 }">赞</li>
          <li @click="tabClick(0)" :class="{ active: type == 0 }">官方通知</li>
        </ul>
        <div
          class="news-list"
          v-infinite-scroll="getData"
          infinite-scroll-disabled="busy"
          infinite-scroll-
          distance="10"
        >
          <template v-if="type == 1">
            <information-list v-for="(item, i) in articleDataList"
            :key="i"
            :dataList="item"
            :index="i" :likeno="true"></information-list>
          </template>
          <template v-if="type == 2">
            <information-list v-for="(item, i) in articleDataList"
            :key="i"
            :dataList="item"
            :index="i" :likeno="false"></information-list>
          </template>
          <template v-if="type == 0">
            <authority-notice v-for="(item, i) in articleDataList"
            :key="i"
            :dataList="item"
            :index="i"></authority-notice>
          </template>
          <div v-if="dataLoadNomore" class="loading-all">没有更多数据</div>
          <div v-else class="loading-all loading">正在加载中，请稍等…</div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import HeaderBar from "@/components/Header.vue";
import UserNav from "@/components/UserLeftNav.vue";
import UserHead from "@/components/UserHead.vue";
import InformationList from "@/components/InformationList.vue";
import ActiveNotice from "@/components/ActiveNotice.vue";
import AuthorityNotice from "@/components/AuthorityNotice.vue";
import infiniteScroll from "vue-infinite-scroll";
export default {
  name: "Home",
  directives: { infiniteScroll },
  components: {
    HeaderBar,
    UserNav,
    UserHead,
    InformationList,
    ActiveNotice,
    AuthorityNotice,
  },
  data() {
    return {
      type: 1,
      busy: false,
      dataLoadNomore: false,
      articleDataList: [],
      urlSwitch: "myMessageList",
      page: 1,
      size: 10,
      allTotal: 0,
    };
  },
  methods: {
    tabClick(num) {
      this.type = num;
      this.page = 1;
      this.articleDataList = [];
      this.getData();
    },
    getData() {
      this.busy = true;
      this.$api[this.urlSwitch]({
        current: this.page,
        size: this.size,
        type: this.type,
      }).then((res) => {
        this.allTotal = res.data.data.total;
        res.data.data.records.forEach((item, index) => {
          if (item.imgStr) {
            item.imgStr = item.imgStr.split(",");
          } else {
            item.imgStr = [];
          }
        });
        this.articleDataList = this.articleDataList.concat(
          res.data.data.records
        );
        if (res.data.data.current < res.data.data.pages) {
          this.page += 1;
          this.busy = false;
          this.dataLoadNomore = false;
        } else {
          this.dataLoadNomore = true;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.main {
  width: 1000px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  .mainconten-right {
    width: 740px;
    background: #fff;
    .tab-bar {
      line-height: 2.5;
      padding: 10px 24px 0;
      border-bottom: 1px solid #efefef;
      li {
        float: left;
        margin-right: 50px;
        font-size: 18px;
        cursor: pointer;
        &.active {
          font-weight: bolder;
          border-bottom: 4px solid #317DFF;
          border-radius: 2px;
        }
      }
    }
    .news-list {
      width: 100%;
      padding: 0 24px;
    }
    .loading-all {
      width: 100%;
      height: 52px;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
      font-size: 15px;
      font-weight: 400;
      color: #666666;
      border-top: 10px solid #f7f7f7;
      text-align: center;
      line-height: 42px;
    }
    .loading {
      background: url("../../assets/images/loading-icon.png") no-repeat 238px
        center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/personalInformation.vue